import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

export function ClaudiaIcon({ className, ...props }: React.SVGProps<SVGSVGElement>) {
  return <Sparkles {...props} className={cn("text-primary", className)} />;
}
